<template>
  <button
    :class="{
      'branded-fare-card': true,
      'branded-fare-card--selected': is_selected,
    }"
    role="button"
    type="button"
    @click="select_flight_offer()"
  >
    <div
      :class="{
        'branded-fare-card__head': true,
        'branded-fare-card__head--selected': is_selected,
      }"
    >
      <span
        :class="{
          'branded-fare-card__radio': true,
          'branded-fare-card__radio--selected': is_selected,
        }"
      >
        <span class="branded-fare-card__radio-dot"></span>
      </span>
      <span class="branded-fare-card__head__title">
        <span class="branded-fare-card__head__title-fare">
          {{ branded_fare | capitalize }}
        </span>
        <span class="branded-fare-card__head__title-price">
          {{ formatted_price }}
        </span>
      </span>
    </div>

    <div
      v-if="filtered_amenities.length"
      :class="{
        'branded-fare-card__amenities': true,
        'branded-fare-card__amenities--selected': is_selected,
      }"
    >
      <div class="branded-fare-card__amenities-container">
        <div class="branded-fare-card__amenities-scroller">
          <branded-fare-amenity
            v-for="amenity in filtered_amenities"
            :key="`amenity:${amenity.code}:${_uid}`"
            :item="amenity"
          />
        </div>
      </div>
    </div>
  </button>
</template>

<script>
  import { get_branded_fare_label } from '@liveflight/providers';
  import { apply_markup_to_number } from '@liveflight/utilities/price';
  import { get_amenity_info } from '@liveflight/resources';
  import { show_amenity } from './logic';
  import BrandedFareAmenity from './amenity.vue';

  export default {
    name: 'branded-fare-card',
    components: {
      'branded-fare-amenity': BrandedFareAmenity,
    },
    props: {
      flight_offer: {
        type: Object,
        required: true,
      },
      selected_flight_offer_id: {
        type: String,
        required: true,
      },
      amenities: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      branded_fare() {
        return get_branded_fare_label(this.flight_offer);
      },
      formatted_price() {
        const { grandTotal, currencySymbol } = this.flight_offer.price || {};
        const live_price = apply_markup_to_number(
          this.flight_offer,
          grandTotal
        );
        return `${live_price} ${currencySymbol}`;
      },
      filtered_amenities() {
        return this.amenities.filter(show_amenity).map(get_amenity_info);
      },
      is_selected() {
        return String(this.flight_offer.id) === this.selected_flight_offer_id;
      },
    },
    methods: {
      select_flight_offer() {
        this.$emit('select-flight-offer', this.flight_offer);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .branded-fare-card {
    margin: $grid-gutter-width / 3 0;
    padding: 0;
    display: flex;
    flex-direction: column;

    border: 1px solid $light-gray;
    background-color: transparent;
    border-radius: $border-radius-lg * 2;

    width: 100%;
    transition-duration: 300ms;
    overflow: hidden;

    &__radio {
      border-radius: 50%;
      border: 1px solid $light-gray;
      padding: $grid-gutter-width / 6;

      min-width: 20px;
      min-height: 20px;
      max-width: 20px;
      max-height: 20px;

      &-dot {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: transparent;
      }

      &--selected {
        & > .branded-fare-card__radio-dot {
          border: 1px solid $light-gray;
          background-color: var(--primary) !important;
        }
      }
    }

    &__head {
      display: flex;
      gap: $grid-gutter-width / 3;
      padding: $grid-gutter-width / 2 $grid-gutter-width * 2 / 3;

      line-height: normal;
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;

      &__title {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        &-price {
          color: var(--primary);
        }
      }
    }

    &__amenities {
      padding: $grid-gutter-width * 2 / 3;

      &-container {
        position: relative;
        @include scrollbar();
        min-height: 200px;
        max-height: 200px;
        overflow-y: auto;
        overflow-x: hidden;

        &::after {
          content: '';
          position: sticky;
          display: block;
          bottom: 0;
          left: 0;

          width: 100%;
          height: 20px;
          background: linear-gradient(
            180deg,
            transparent 0%,
            $white 100%
          ) !important;
          z-index: 9999;
        }
      }
      &-scroller {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: $grid-gutter-width / 2;
      }

      border-top: 1px solid $light-gray;

      &--selected {
        border-top: 1px solid var(--primary);
      }
    }

    &:hover {
      box-shadow: 0 0 13px 0 rgba(0, 0, 0, 0.25);
      .branded-fare-card__radio-dot {
        background-color: $light-gray;
      }
    }

    &--selected {
      border: 2px solid var(--primary);
      box-shadow: 0 0 13px 0 rgba(0, 0, 0, 0.25);
    }
  }
</style>
